import React from "react";
import { createFileRoute } from "@tanstack/react-router";
//
import { useTranslation } from "react-i18next";
import { Center, Stack, Box } from "@mantine/core";
import {
  SpringOnboardingText,
  SpringOnboardingTitle,
} from "@components/Typography";

export const Route = createFileRoute("/telus/thank-you")({
  component: TelusThanksPage,
});

function TelusThanksPage(): React.ReactElement {
  const { t } = useTranslation();

  return (
    <Box pt="50">
      <Stack align="center" gap="md" mt="xl" px="lg">
        <SpringOnboardingTitle order={2}>
          {t("telus.thankYouPage.title")}
        </SpringOnboardingTitle>

        <Center mt="md" w={{ xs: "100%", md: "60%" }}>
          <Stack>
            <SpringOnboardingText data-testid="enroll-success-text">
              {t("telus.thankYouPage.mainCopy")}
            </SpringOnboardingText>
          </Stack>
        </Center>
      </Stack>
    </Box>
  );
}
